import JSBridge from '@/helpers/jsbridge';

export function formatDate(value, type = 'short') {
  const date = new Date(value);
  return `${date.getDate()} ${date.toLocaleString('id-ID', { month: type })} ${date.getFullYear()}`;
}

export function formatBalance(value) {
  return value.toLocaleString('id-ID').replace(/,/g, '.');
}

export async function generateSaintLocoHeaders() {
  const jsBridge = new JSBridge();
  const token = await jsBridge.generateAuthToken();

  let agent = '';

  if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) agent = 'ios';
  else if (/Android/i.test(navigator.userAgent)) agent = 'android';

  return {
    'client-id': `ovo_${agent}`,
    'app-id': 'webview-promos',
    os: agent,
    service: 'saintloco',
    Authorization: token,
  };
}

export async function generateAgwHeaders() {
  const jsBridge = new JSBridge();
  const token = await jsBridge.generateAuthToken();
  const appVersion = await jsBridge.generateAppVersion();
  let agent = '';

  if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) agent = 'ios';
  else if (/Android/i.test(navigator.userAgent)) agent = 'android';

  return {
    'client-id': `ovo_${agent}`,
    'app-version': appVersion,
    os: agent,
    Authorization: `Bearer ${token}`,
  };
}

export function debounce(fn, delay) {
  var timeoutID = null;
  return function() {
    clearTimeout(timeoutID);
    var args = arguments;
    var that = this;
    timeoutID = setTimeout(function() {
      fn.apply(that, args);
    }, delay);
  };
}
